
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class BaseButtonLanding extends Vue {
  @Prop({ default: 'blue' }) styleButton!: string;
  @Prop({ default: '' }) text!: string;
  @Prop({ default: false }) disabled!: boolean;
}
